import { useEffect, useRef, useState, useMemo } from "react";
import DefaultBook from "../Images/defaultBook.png";
import BooksService from "../Services/Books";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "../Styles/BookDetail.css";
import Slider from "react-slick";
import i18n from "../i18n";
import Favfill from "../assets/img/favadd.svg";
import Favempty from "../assets/img/fav.svg";
import { BookContentType } from "./Epub";
import { useTranslation } from "react-i18next";
import { userId } from "../Contexts/LocaleContext";
import "react-toastify/dist/ReactToastify.css";
import { LogInModel } from "./LoginModel";
import leftArrow from "../assets/img/leftArrow1.png";
import rightArrow from "../assets/img/rightArrow1.png";
import EpubServices from "../Services/Epub";
import closeicon from "../Images/close-round-border.svg";
import bookmarkIcon from "../Images/Bookmark.svg"
import Loader from "./Loader";
import BookCoverPopup from "../Components/BookCoverPopup";
import BookSeo from "../Components/BookSeo";
import { listToTree } from "../utils/tocUtils";

const BookDetailPage = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [bookDetail, setBookDetail] = useState<any>(undefined);
  const [refresh, setRefresh] = useState(false);
  const [relateds, setRelatedBooks] = useState<any[] | undefined>(undefined);

  // it useridentity is change in token etc.. than this effect on favourite
  const UserIdentity = localStorage.getItem("UserId") as any;
  console.log("BookDetailPage Render - UserIdentity:", UserIdentity);

  const location = useLocation();
  const params = useParams<{
    bookid?: string;
    slug?: string;
  }>();
  const state = location.state as {
    bookSlug: string;
    bookId: string;
    bookName: string;
    authorId: string;
    authorName: string;
    authorSlug: string;
    special: string;
    langId: string;
    catId: string;
    catName: string;
    catSlug: string;
    index: number;
    searched: string;
    pathname: string;
    /** Pre-fetched by DebugLocation in App.tsx on direct URL load */
    bookDetail?: any;
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: <img src={leftArrow} alt="" height="40px" />,
    nextArrow: <img src={rightArrow} alt="" height="40px" />,
  };

  const [logIn, setLogIn] = useState<boolean>(false);

  const closeModal = () => {
    setLogIn(false);
  };

  const [isLiked, setIsLiked] = useState<boolean>(false);
  const [toggleFav, setToggleFav] = useState<boolean>(false);
  const [lang, showLang] = useState("");
  const [bookMark, setBookMark] = useState<boolean>(false);
  const [bookMarkData, setBookMarkData] = useState<any[] | undefined | any>(
    undefined
  );
  const [bookId, setBookId] = useState<string>("")

  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<'description' | 'toc'>('description');
  const [expandedNodes, setExpandedNodes] = useState<Set<string>>(new Set());
  const [lastPos, setLastPos] = useState<any>(null);
  const [lastFontSize, setLastFontSize] = useState<number>(100);
  const [toc, setToc] = useState<any[]>([]);
  const [progress, setProgress] = useState<number>(0);
  const [showCoverPopup, setShowCoverPopup] = useState(false);

  // Font mapping based on bookLanguageId
  const getFontFamilyByLanguageId = (languageId: string): string => {
    console.log("languageId", languageId);
    const fontMap: Record<string, string> = {
      english: "NalandaTim, Verdana, sans-serif",
      hindi: "ChanakyaUni, NalandaTim, Tunga",
      kannada: "Tunga, sans-serif",
      bangla: "Shonar Bangla, sans-serif",
      tamil: "Latha, sans-serif",
      oriya: "Kalinga, sans-serif",
      bengali: "Shonar Bangla, sans-serif",
      odia: "Kalinga, sans-serif",
    };
    return fontMap[languageId?.toLowerCase()] || "ChanakyaUni, NalandaTim, Tunga";
  };

  // Optimization: Memoize tree and flattened TOC to avoid expensive re-calculation
  const navigationTree = useMemo(() => listToTree(toc), [toc]);
  const flatToc = useMemo(() => toc, [toc]); // Keep original order for progress calculation

  const notificationRef = useRef<any>(null);

  const showNotification = (message: any) => {
    notificationRef.current.innerText = message;
    notificationRef.current.style.display = "block";

    setTimeout(() => {
      notificationRef.current.style.display = "none";
    }, 3000); // Hide the notification after 2 seconds
  };

  const notify = () => {
    if (UserIdentity) {
      showNotification(
        !isLiked
          ? localStorage.getItem("lan") === "hindi"
            ? "पुस्तक को सफलतापूर्वक मेरी पसंद में जोड़ा गया है।"
            : "Book has been successfully added to the favourites"
          : localStorage.getItem("lan") === "hindi"
            ? "पुस्तक मेरी पसंद से हटा दी गई है।"
            : "Book has been removed from favourites"
      );
    }
  };

  const toggleLike = () => {
    !isLiked
      ? BooksService.addFavourite(bookId).then((res) => {
        res.status && setIsLiked(true);
      })
      : BooksService.removeFavourite(bookId).then((res) => {
        res.status && setIsLiked(false);
      });
    setToggleFav((x) => !x);
  };

  const [loginState, setLoginState] = useState<boolean>(false);

  const handleLoginStateChange = (newState: any) => {
    setLoginState(newState === true);
    navigate(`/reader/books/` + state?.bookSlug, {
      state: {
        bookDetailId: bookId,
        bookName: state?.bookName,
        slug: state?.bookSlug,
        label: bookId,
        type: BookContentType.books,
      },
    });
  };

  const [description, setDescription] = useState({
    __html: "",
  });

  const toggleNode = (nodeId: string) => {
    setExpandedNodes((prev) => {
      const next = new Set(prev);
      if (next.has(nodeId)) {
        next.delete(nodeId);
      } else {
        next.add(nodeId);
      }
      return next;
    });
  };

  const renderTocNode = (node: any, index: number, flatIndex?: number, fontFamily?: string) => {
    const isExpanded = expandedNodes.has(node.navId || `node-${index}`);
    const hasChildren = node.children && node.children.length > 0;

    // Determine if read/unread based on progress
    const totalChapters = flatToc.length;
    const readCount = Math.floor(totalChapters * progress / 100);

    // If flatIndex is provided, use it. Otherwise, find it in the flat list.
    const currentFlatIndex = flatIndex !== undefined ? flatIndex : flatToc.findIndex(n => n.navId === node.navId);
    const isRead = currentFlatIndex !== -1 && currentFlatIndex < readCount;

    return (
      <li key={node.navId || index} className="toc-node">
        <div
          className={`node ${isRead ? 'read' : 'unread'}`}
          onClick={() => hasChildren && toggleNode(node.navId || `node-${index}`)}
          style={{ cursor: hasChildren ? 'pointer' : 'default' }}
        >
          {hasChildren ? (
            <span className="node-toggle">
              {isExpanded ? '-' : '+'}
            </span>
          ) : (
            <span className="node-bullet">•</span>
          )}
          <div
            className="node-label"
            onClick={(e) => {
              if (!hasChildren) {
                e.stopPropagation();
                console.log("Navigating to TOC Node - Book:", bookDetail?.slug, "With Data:", "bookDetailId ", bookDetail?.id,
                  "bookName:", bookDetail?.name,
                  "slug:", bookDetail?.slug,
                  "location:", node.srcFile + (node.srcAnchor ? `#${node.srcAnchor}` : "") || node.href,
                  "type: ", BookContentType.books);

                navigate(`/reader/books/` + bookDetail?.slug, {
                  state: {
                    bookDetailId: bookDetail?.id,
                    bookName: bookDetail?.name,
                    slug: bookDetail?.slug,
                    location: node.srcFile + (node.srcAnchor ? `#${node.srcAnchor}` : "") || node.href,
                    tocNode: node,
                    type: BookContentType.books,
                  },
                });
              }
            }}
            style={{ cursor: 'pointer', fontFamily: fontFamily }}
          >
            {node.label || node.title}
          </div>
        </div>
        {hasChildren && (
          <ul className={`children ${isExpanded ? 'expanded' : ''}`}>
            {node.children.map((child: any, cIdx: number) => {
              // Pass the child's global index for correct progress styling
              // Efficiency: we could optimize this further with a Map, but for normal TOCs this is fast enough
              const childFlatIndex = flatToc.findIndex(n => n.navId === child.navId);
              return renderTocNode(child, `${index}-${cIdx}` as any, childFlatIndex, fontFamily);
            })}
          </ul>
        )}
      </li>
    );
  };

  function createMarkup() {
    return { __html: description.__html };
  }

  const hasVisibleDescription = useMemo(() => {
    const html = description?.__html || "";
    const text = html
      .replace(/&nbsp;/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();
    return text.length > 0;
  }, [description]);

  const hasToc = toc.length > 0;

  useEffect(() => {
    if (!hasVisibleDescription && activeTab === "description") {
      if (hasToc) setActiveTab("toc");
    }
  }, [hasVisibleDescription, activeTab, hasToc]);

  useEffect(() => {
    if (!hasToc && activeTab === "toc") {
      if (hasVisibleDescription) setActiveTab("description");
    }
  }, [hasToc, activeTab, hasVisibleDescription]);

  const indicatorTranslate = useMemo(() => {
    if (!hasVisibleDescription && !hasToc) return "0";
    if (!hasVisibleDescription) return "0";
    if (!hasToc) return "0";
    return activeTab === "description" ? "0" : "172px";
  }, [hasVisibleDescription, hasToc, activeTab]);

  useEffect(() => {
    if (state?.bookId) {
      setBookId(state.bookId);
      return;
    }

    const slugParam = params.slug || params.bookid;
    if (!slugParam) return;

    const isMongoId = /^[0-9a-fA-F]{24}$/.test(slugParam);
    setBookId(isMongoId ? slugParam : `slug-${slugParam}`);
  }, [state?.bookId, params.slug, params.bookid]);

  useEffect(() => {
    if (!localStorage.getItem("lan")) {
      const lang =
        process.env.REACT_APP_SITEMAP_LANG === "english" ? "english" : "hindi";
      localStorage.setItem("lan", lang);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (bookId) {
        try {
          setLoading(true);

          // If DebugLocation already fetched the book detail (direct URL load),
          // reuse it and only fetch navigation details.
          const prefetched = state?.bookDetail;

          const [bookRes, navRes] = await Promise.all([
            prefetched ? Promise.resolve({ status: true, result: prefetched }) : BooksService.getBookDetail(bookId),
            BooksService.getNavigationDetails(bookId),
          ]);

          if (prefetched) {
            console.log("BookDetailPage: using pre-fetched bookDetail from navigation state, skipping API call.");
          } else {
            console.log("API Responses - Book:", bookRes, "Nav:", navRes);
          }

          if (bookRes?.status) {
            setDescription({ __html: bookRes.result?.description });
            setBookDetail(bookRes.result);
            setIsLiked(bookRes.result?.isFavourite);
          }

          if (navRes?.status) {
            setToc(navRes.result?.navigationTree || []);
            if (navRes.result?.lastPosition) {
              console.log("Last Position:", navRes.result.lastPosition);
              setLastPos(navRes.result.lastPosition);
            }
            // Restore saved font size (fallback to 100 if null / NaN / "null" / "")
            const rawFont = navRes.result?.bookFontSize;
            const parsedFont = parseFloat(rawFont);
            setLastFontSize(
              rawFont !== null && rawFont !== undefined && rawFont !== "" && rawFont !== "null" && !isNaN(parsedFont)
                ? parsedFont
                : 100
            );
            if (navRes.result?.navOrder) {
              const totalChapters = navRes.result.navigationTree.length;
              setProgress((navRes.result.navOrder / totalChapters) * 100);
            }
          }

        } catch (error) {
          console.error("fetchData Error:", error);
        } finally {
          console.log("fetchData Completed");
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [i18n.language, bookId, UserIdentity]);


  useEffect(() => {
    if (state?.bookId && UserIdentity) {
      EpubServices.getbookmark("bookmarks", state?.bookId).then((res: any) => {
        if (res.status) {
          setBookMarkData(res?.result);
        }
      });
    }
  }, [refresh, i18n.language, userId, state?.bookId]);

  useEffect(() => {
    if (!bookId) return;
    setRefresh(false);
    BooksService.getRelatedBooks(bookId, UserIdentity !== "" ? UserIdentity : "").then((res) => {
      if (res.status) {
        setRelatedBooks(res.result);
      }
    });
  }, [refresh, i18n.language, bookId, UserIdentity]);

  useEffect(() => {
    if (state?.langId) {
      BooksService.GetLanguageDataById(state.langId).then((res) => {
        showLang(res?.result?.name);
      });
    }
  }, [i18n.language, state?.langId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {bookDetail?.slug ? (
        <BookSeo
          book={bookDetail}
          canonicalPath={`/books/${bookDetail.slug}`}
        />
      ) : null}
      <div
        className="newcontainer"
        style={{ backgroundColor: "#FFF6E1", padding: "1px 0", marginTop: 0 }}
      >
      <div
        className="breadcrumbs-head newcontainer"
        style={{
          width: "100%",
          marginTop: "-175px",
          background: "none",
          backgroundColor: "#ffedbc",
          height: "240px",
          borderBottom: "2px solid #fff",
          paddingTop: 0,
        }}
      >
        <div className="breadcrumbs">
          <div
            className="containers"
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "rgb(209, 21, 1)",
              top: "155px",
              fontFamily: "ChanakyaUni",
            }}
          >
            {window.location.pathname === "/profile/fav" + state?.bookSlug &&
              t("E_books_tr")}
            {window.location?.pathname === "/books/" + state?.bookSlug &&
              t("E_books_tr")}
            {window.location?.pathname === "/books/special/" + state?.bookSlug &&
              t("Special_E_books_tr")}
            {state?.authorId !== undefined && <span>{state?.authorName}</span>}
            {state?.langId !== undefined && <span>{lang}</span>}
            {state?.catId ? t("E_books_tr") : ""}
            <div
              style={{
                fontSize: "19px",
                fontWeight: 600,
                color: "#2d2a29",
                marginTop: "-8px",
              }}
            >
              <Link style={{ marginRight: "8px", color: "#2d2a29" }} to="/">
                {t("Home_tr")}
              </Link>
              {window.location?.pathname === "/books/" + state?.bookSlug ? (
                <Link
                  to={"/books"}
                  style={{ marginRight: "6px", color: "#2d2a29" }}
                >
                  / {t("E_books_tr")}
                </Link>
              ) : (
                ""
              )}
              {window.location?.pathname ===
                "/books/special/" + state?.bookSlug ? (
                <Link
                  to={"/books/special"}
                  style={{ marginRight: "6px", color: "#2d2a29" }}
                >
                  / {t("Special_E_books_tr")}
                </Link>
              ) : (
                ""
              )}

              {state?.authorId !== undefined ? (
                <>
                  <Link
                    to={"/author/" + state?.authorSlug}
                    state={{
                      authorId: state?.authorId,
                      authorName: state?.authorName,
                      authorSlug: state?.authorSlug,
                    }}
                    style={{ marginRight: "6px", color: "#2d2a29" }}
                  >
                    {/* author name in hindi and english */}
                    /{state?.authorName}
                  </Link>
                  <Link
                    to={"/books/author/" + state?.authorSlug}
                    state={{
                      authorId: state?.authorId,
                      authorName: state?.authorName,
                      authorSlug: state?.authorSlug,
                    }}
                    style={{ marginRight: "6px", color: "#2d2a29" }}
                  >
                    / {t("E_books_tr")}
                  </Link>
                </>
              ) : (
                ""
              )}
              {state?.catId !== undefined && (
                <Link
                  to={"/books/category/+"}
                  state={{
                    catId: state?.catId,
                  }}
                  style={{ marginRight: "8px", color: "#2d2a29" }}
                >
                  / {t("E_books_tr")}
                </Link>
              )}
              {state?.langId !== undefined && (
                <>
                  <Link
                    to={"/books/language/ +"}
                    state={{
                      langId: state?.langId,
                    }}
                    style={{ marginRight: "8px", color: "#2d2a29" }}
                  >
                    / {lang}
                  </Link>
                  <Link
                    to={"/books/language/ +"}
                    state={{
                      langId: state?.langId,
                    }}
                    style={{ marginRight: "8px", color: "#2d2a29" }}
                  >
                    / {t("E_books_tr")}
                  </Link>
                </>
              )}
              <span>/ {bookDetail?.name}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div style={{ marginBottom: "75px" }}>
          <div className="row">
            <div>
              {bookDetail ? (
                <div
                  className="containers card-gst"
                  style={{
                    width: "100%",
                    marginTop: "25px",
                    backgroundColor: "#FFFAF0",
                    boxShadow: "0px 0px 10px 0px #dcd1b8",
                  }}
                >
                  <div className="mat-card row" key={`book-${bookDetail.id}`} style={{ display: 'flex', alignItems: 'stretch', padding: '15px' }}>
                    <div className="single-product col-4 col-lg-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <div
                        style={{
                          border: "1px solid #eadfc8",
                          padding: "30px",
                          background: "#fff",
                          borderRadius: "5px",
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={bookDetail.bookPath}
                          onError={(e) => {
                            e.currentTarget.src = DefaultBook;
                          }}
                          onClick={() => {
                            setShowCoverPopup(true);
                          }}
                          alt={bookDetail.altText || bookDetail.name}
                          title={bookDetail.name}
                          className="bkdetailimg"
                          style={{ cursor: "pointer" }}
                          width="256"
                          height="362"
                        />
                      </div>
                    </div>

                    <div className="single-product-author col-8 col-lg-8" style={{ display: 'flex', flexDirection: 'column' }}>
                      <div>
                        <div className="single-bookdetail-heading">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <label
                              style={{
                                fontFamily: "ChanakyaUni,NalandaTim,Tunga",
                                fontSize: "22px",
                                fontWeight: 600,
                                color: "#472d1e",
                                margin: "12px 0 0",
                                fontStyle: "normal",
                              }}
                            >
                              {bookDetail.name}
                            </label>
                            <label
                              onClick={() => {
                                if (!UserIdentity) setLogIn(true);
                              }}
                              style={{ display: "flex", margin: 0 }}
                            >
                              <label
                                style={{
                                  display:
                                    bookMarkData?.length > 0 ? "block" : "none",
                                  marginRight: "10px",
                                }}
                              >
                                <div style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setBookMark(
                                      bookMark === true ? false : true
                                    );
                                  }}
                                >
                                  <div>
                                    <img src={bookmarkIcon} style={{ width: "45px", height: "45px" }} alt="bookmaarkicon" />
                                  </div>
                                  <div>
                                    {bookMark && userId && (
                                      <div className="bkmarkicon-style">
                                        <div
                                          style={{
                                            display: "flex",
                                            backgroundColor: "#ff6427",
                                          }}
                                        >
                                          <p
                                            style={{
                                              color: "#fff",
                                              fontStyle: "normal",
                                              lineHeight: "normal",
                                              borderBottom: "none",
                                              padding: "0 0 0 10%",
                                              margin: 0,
                                            }}
                                          >
                                            {t("bk_mark_tr")}
                                          </p>
                                          <img
                                            src={closeicon}
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              margin: "4px 0 0 10px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => setBookMark(false)}
                                            alt=""
                                          />
                                        </div>
                                        <ol style={{ paddingLeft: "20px", fontSize: "20px" }}>
                                          {bookMarkData &&
                                            bookMarkData?.map(
                                              (item: any, index: number) => (
                                                <li
                                                  key={index}
                                                  onClick={() => {
                                                    navigate(
                                                      `/reader/books/` +
                                                      bookDetail?.slug,
                                                      {
                                                        state: {
                                                          bookDetailId:
                                                            bookDetail?.id,
                                                          bookName:
                                                            bookDetail?.name,
                                                          slug: bookDetail?.slug,
                                                          location: item?.cfi,
                                                          chapterName: item?.name,
                                                          type: BookContentType.books,
                                                          fontsize: lastFontSize,
                                                        },
                                                      }
                                                    );
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      borderBottom: "none",
                                                      padding: 0,
                                                      margin: "0 0 0 5px",
                                                      color: "#000",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    {item?.name}
                                                  </p>
                                                </li>
                                              )
                                            )}
                                        </ol>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </label>
                              <label
                                onClick={() => {
                                  toggleLike();
                                  notify();
                                }}
                              >
                                <img
                                  src={isLiked ? Favfill : Favempty}
                                  alt="img"
                                  style={{ width: "45px", cursor: "pointer" }}
                                />
                              </label>
                            </label>
                          </div>
                        </div>

                        {bookDetail.author ? (
                          <div>
                            <p>
                              <label>{t("Authors_tr")}</label>
                              {bookDetail.author}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        {bookDetail.bookLanguage ? (
                          <div>
                            <p>
                              <label>{t("Language_tr")} </label>
                              {bookDetail.bookLanguage}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div style={{ marginTop: "20px" }}>
                        <div
                          className="notification-bar"
                          ref={notificationRef}
                          style={{
                            color: "#ff3d28",
                            fontSize: "20px",
                            marginBottom: "10px",
                          }}
                        ></div>

                        <div className="actions">
                          {progress > 0 && (
                            <div className="book-progress">
                              <div className="book-progress__label">{Math.round(progress)} %</div>
                              <div className="book-progress__track">
                                <div className="book-progress__value" style={{ width: `${progress}%` }}></div>
                              </div>
                            </div>
                          )}
                          <div className="buttons">
                            {progress === 0 ? (
                              <button
                                className="btn-book-action"
                                onClick={() => {
                                  if (UserIdentity) {
                                    navigate(`/reader/books/` + bookDetail?.slug, {
                                      state: {
                                        bookDetailId: bookDetail?.id,
                                        bookName: bookDetail?.name,
                                        slug: bookDetail?.slug,
                                        label: bookDetail?.label,
                                        type: BookContentType.books,
                                      },
                                    });
                                  } else {
                                    setLogIn(true);
                                  }
                                }}
                              >
                                {t("Read_Book_tr")}
                              </button>
                            ) : (
                              <>
                                <button
                                  className="btn-book-action"
                                  onClick={() => {
                                    if (UserIdentity) {
                                      navigate(`/reader/books/` + bookDetail?.slug, {
                                        state: {
                                          bookDetailId: bookDetail?.id,
                                          bookName: bookDetail?.name,
                                          slug: bookDetail?.slug,
                                          label: bookDetail?.label,
                                          type: BookContentType.books,
                                        },
                                      });
                                    } else {
                                      setLogIn(true);
                                    }
                                  }}
                                >
                                  {t("Read_From_Start_tr")}
                                </button>
                                <button
                                  className="btn-book-action"
                                  onClick={() => {
                                    navigate(`/reader/books/` + bookDetail?.slug, {
                                      state: {
                                        bookDetailId: bookDetail?.id,
                                        bookName: bookDetail?.name,
                                        slug: bookDetail?.slug,
                                        location: lastPos,
                                        type: BookContentType.books,
                                        fontsize: lastFontSize,
                                      },
                                    });
                                  }}
                                >
                                  {t("Continue_Reading_tr")}
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ margin: "0 45px 5% 40px" }}>
                    <div className="tabs-container">
                      <div className="tabs-line">
                        <div className="tabs" role="tablist">
                          {hasVisibleDescription && (
                            <button
                              className="tab"
                              aria-selected={activeTab === 'description'}
                              onClick={() => setActiveTab('description')}
                            >
                              {t("Description_tr")}
                            </button>
                          )}
                          {hasToc && (
                            <button
                              className="tab"
                              aria-selected={activeTab === 'toc'}
                              onClick={() => setActiveTab('toc')}
                            >
                              {t("Table_of_Contents_tr")}
                            </button>
                          )}
                        </div>
                        <div
                          className="tab-indicator"
                          style={{
                            transform: `translateX(${indicatorTranslate})`,
                            width: '140px'
                          }}
                        ></div>
                      </div>

                      <div className="tab-panels">
                        {hasVisibleDescription && (
                          <div className={`panel ${activeTab === 'description' ? 'active' : ''}`}>
                            <div dangerouslySetInnerHTML={createMarkup()}></div>
                          </div>
                        )}

                        {hasToc && (
                          <div className={`panel ${activeTab === 'toc' ? 'active' : ''}`}>
                            <ul className="toc">
                              {navigationTree.map((node: any, idx: number) => renderTocNode(node, idx, undefined, getFontFamilyByLanguageId(bookDetail?.bookLanguageId)))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="clsslide">
                    {relateds && relateds?.length > 5 ? (
                      <div>
                        <h1
                          style={{ fontSize: "30px!important" }}
                          className="heading-related"
                        >
                          {t("Related_e_books_tr")}
                        </h1>

                        <div
                          style={{
                            paddingBottom: "20px",
                            width: " 97%",
                            left: "18px",
                            position: "relative",
                          }}
                        >
                          <Slider {...settings}>
                            {relateds && relateds?.length > 0
                              ? relateds.map((related) => (
                                <div
                                  style={{ display: "flex" }}
                                  className="slider-books sidebarmargin"
                                  key={`related-${related.id}`}
                                  onClick={() => {
                                    if (
                                      window.location.pathname ===
                                      `/books/` + state?.bookSlug
                                    ) {
                                      navigate(`/books/` + related?.slug, {
                                        state: {
                                          bookId: related?.id,
                                          bookName: related?.name,
                                          bookSlug: related?.slug,
                                          special: window?.location?.pathname,
                                          pathname:
                                            window?.location?.pathname,
                                        },
                                      });
                                    }
                                    if (
                                      window.location.pathname ===
                                      `/books/special/` + state?.bookSlug
                                    ) {
                                      navigate(
                                        `/books/special/` + related?.slug,
                                        {
                                          state: {
                                            bookId: related?.id,
                                            bookName: related?.name,
                                            bookSlug: related?.slug,
                                            special: window?.location?.pathname,
                                            pathname:
                                              window?.location?.pathname,
                                          },
                                        }
                                      );
                                    }
                                    if (
                                      window.location.pathname ===
                                      "/books/author/" +
                                      state?.authorSlug +
                                      "/" +
                                      state?.bookSlug
                                    ) {
                                      navigate(
                                        "/books/author/" +
                                        state?.authorSlug +
                                        "/" +
                                        related?.slug,
                                        {
                                          state: {
                                            bookId: related?.id,
                                            bookName: related?.name,
                                            bookSlug: related?.slug,
                                            authorId: state?.authorId,
                                            authorName: state?.authorName,
                                            authorSlug: state?.authorSlug,
                                            pathname:
                                              window?.location?.pathname,
                                          },
                                        }
                                      );
                                    }
                                    if (
                                      window?.location?.pathname ===
                                      `/books/category/` +
                                      state?.catSlug +
                                      "/" +
                                      state?.bookSlug
                                    ) {
                                      navigate(
                                        `/books/category/` +
                                        state?.catSlug +
                                        "/" +
                                        related?.slug,
                                        {
                                          state: {
                                            bookId: related?.id,
                                            bookName: related?.name,
                                            catId: state?.catId,
                                            catSlug: state?.catSlug,
                                            bookSlug: related?.slug,
                                            pathname:
                                              window?.location?.pathname,
                                          },
                                        }
                                      );
                                    }
                                    if (
                                      window?.location?.pathname ===
                                      `/books/language/` +
                                      state?.langId +
                                      "/" +
                                      state?.bookSlug
                                    ) {
                                      navigate(
                                        `/books/language/` +
                                        state?.langId +
                                        "/" +
                                        related.slug,
                                        {
                                          state: {
                                            bookId: related?.id,
                                            bookName: related?.name,
                                            bookSlug: related?.slug,
                                            langId: state?.langId,
                                            pathname:
                                              window?.location?.pathname,
                                          },
                                        }
                                      );
                                    }
                                    window.location.reload();
                                  }}
                                >
                                  <div>
                                    <img
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      className="imgcenter"
                                      src={
                                        related?.bookThumbPath == null
                                          ? DefaultBook
                                          : related?.bookThumbPath
                                      }
                                      onError={(e) => {
                                        e.currentTarget.src = DefaultBook;
                                      }}
                                      alt={related?.name}
                                      title={related?.name}
                                      width="150"
                                      height="212"
                                    />
                                    <p>{related?.name?.length > 35
                                      ? related?.name?.slice(0, 35) + "..."
                                      : related?.name}</p>
                                  </div>
                                </div>
                              ))
                              : ""}
                          </Slider>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : loading ? (
                <div className="ebooks-category resultnotfound">
                  <Loader loading={loading} />
                </div>
              ) : (
                <div className="ebooks-category resultnotfound">
                  {t("result_not_found_tr")}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <LogInModel
        opens={logIn}
        onCloses={closeModal}
        onLoginStateChange={handleLoginStateChange}
      />
      {bookDetail && (
        <BookCoverPopup
          show={showCoverPopup}
          onClose={() => setShowCoverPopup(false)}
          imagePath={bookDetail.bookPath}
          bookName={bookDetail.name}
        />
      )}
      </div>
    </>
  );
};
export default BookDetailPage;
